module.exports = __webpack_public_path__ + "img/4_99.b1b90f1a.png";